import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TTnaApprovalsState } from './tna-approvals.models';

export const getTnaApprovalState = (state: TPlani8State) => state.tnaApprovalsState;

export const getTnaStepApprovalList = createSelector(
  getTnaApprovalState,
  (state: TTnaApprovalsState) => state.tnaStepApprovalList,
);

export const getTnaStepApprovalDetails = createSelector(
  getTnaApprovalState,
  (state: TTnaApprovalsState) => state.tnaStepApprovalDetails,
);

export const getTnaSTepApprovalPendingList = createSelector(
  getTnaApprovalState,
  (state: TTnaApprovalsState) => state.tnaStepApprovalPendingList,
);

export const getTnaStepApprovaPendinglDetails = createSelector(
  getTnaApprovalState,
  (state: TTnaApprovalsState) => state.tnaStepApprovalPendingDetails,
);

export const getUserPaginationOption = createSelector(
  getTnaApprovalState,
  (state: TTnaApprovalsState) => state.userPaginationOption,
);
